"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var validate_js_1 = __importDefault(require("validate.js"));
var moment_1 = __importDefault(require("moment"));
var Constraint_1 = __importDefault(require("./Constraint"));
var ValidationColor_1 = __importDefault(require("./util/ValidationColor"));
var PhoneUtil_1 = require("./util/PhoneUtil");
var DATE_FORMAT = moment_1.default.ISO_8601;
validate_js_1.default.validators.videoCategoryLastSelected = function (categories, errorMessage) {
    var _a, _b, _c, _d, _e, _f;
    var lastWithOptionsReducer = function (acc, cur, index) { return (cur.length ? index : acc); };
    var lastChosenReducer = function (acc, cur, index) { return (cur !== '' ? index : acc); };
    for (var i = 0; i < categories.length; i++) {
        // only validate if at least one category level has been chosen, since category is an optional field
        if (((_b = (_a = categories === null || categories === void 0 ? void 0 : categories[i]) === null || _a === void 0 ? void 0 : _a.chosenCategoryLevels) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            continue;
        }
        var lastWithOptions = (_d = (_c = categories === null || categories === void 0 ? void 0 : categories[i]) === null || _c === void 0 ? void 0 : _c.categoryLevels) === null || _d === void 0 ? void 0 : _d.reduce(lastWithOptionsReducer, 0);
        var lastChosen = (_f = (_e = categories === null || categories === void 0 ? void 0 : categories[i]) === null || _e === void 0 ? void 0 : _e.chosenCategoryLevels) === null || _f === void 0 ? void 0 : _f.reduce(lastChosenReducer, undefined);
        if (lastChosen !== lastWithOptions) {
            return errorMessage;
        }
    }
    return undefined;
};
validate_js_1.default.validators.videoCategoryNotEmpty = function (categories, option) {
    var _a, _b;
    if (((_b = (_a = categories === null || categories === void 0 ? void 0 : categories[0]) === null || _a === void 0 ? void 0 : _a.chosenCategoryLevels) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        return undefined;
    }
    return option;
};
validate_js_1.default.validators.emailArray = function (emails, errorMessage) {
    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    for (var i = 0; i < emails.length; i++) {
        if (emails[i] && !emailRegex.test(emails[i])) {
            return errorMessage;
        }
    }
    return undefined;
};
validate_js_1.default.validators.standardPasswordCharacters = function (value, errorMessage) {
    if (String(value).match(/[^\w]/)) {
        return errorMessage;
    }
    return undefined;
};
validate_js_1.default.validators.datetimeEndAfterStart = function (value, option) {
    if (!value.start || !value.end || new Date(value.start) < new Date(value.end)) {
        return undefined;
    }
    return option;
};
validate_js_1.default.validators.datetimeRange = function (value, option) {
    var isValidDate = function (val) {
        var checkDate = moment_1.default(val, DATE_FORMAT, true).isValid()
            ? moment_1.default(val, DATE_FORMAT, true)
            : undefined;
        var checkStartDate = moment_1.default(option.start, DATE_FORMAT, true).isValid()
            ? moment_1.default(option.start, DATE_FORMAT, true)
            : undefined;
        var checkEndDate = moment_1.default(option.end, DATE_FORMAT, true).isValid()
            ? moment_1.default(option.end, DATE_FORMAT, true)
            : undefined;
        if (checkDate) {
            if (checkStartDate) {
                if (checkDate.isBefore(checkStartDate)) {
                    return false;
                }
            }
            if (checkEndDate) {
                if (checkDate.isAfter(checkEndDate)) {
                    return false;
                }
            }
        }
        return true;
    };
    if (isValidDate(value === null || value === void 0 ? void 0 : value.start) && isValidDate(value === null || value === void 0 ? void 0 : value.end)) {
        return undefined;
    }
    return option.message || 'Invalid DateTime';
};
validate_js_1.default.validators.array = function (value, option) {
    if (!Array.isArray(value)) {
        if (option === null || option === void 0 ? void 0 : option.onlyArray) {
            return (option === null || option === void 0 ? void 0 : option.notArray) || 'Not Array';
        }
        return undefined;
    }
    if ((option === null || option === void 0 ? void 0 : option.maximum) && value.length > (option === null || option === void 0 ? void 0 : option.maximum)) {
        return (option === null || option === void 0 ? void 0 : option.tooLong) || 'Too Long';
    }
    return undefined;
};
/**
 * Either a valid faxContact object or a valid number
 * @param value
 * @param option
 */
validate_js_1.default.validators.faxContact = function (value, option) {
    if (value === null || value === void 0 ? void 0 : value.faxContactId) {
        return undefined;
    }
    if ((value === null || value === void 0 ? void 0 : value.length) > 255) {
        return (option === null || option === void 0 ? void 0 : option.tooLong) || 'Too Long';
    }
    if ((option === null || option === void 0 ? void 0 : option.required) && (!value || value === '' || (value === null || value === void 0 ? void 0 : value.length) < 1)) {
        return (option === null || option === void 0 ? void 0 : option.tooShort) || 'Too Short';
    }
    if (value && (option === null || option === void 0 ? void 0 : option.allowInvalidPhoneNumber)) {
        return undefined;
    }
    if (!value && (option === null || option === void 0 ? void 0 : option.allowInvalidPhoneNumber) && !(option === null || option === void 0 ? void 0 : option.required)) {
        return undefined;
    }
    if (value && PhoneUtil_1.PhoneUtil.isValid(value)) {
        return undefined;
    }
    return (option === null || option === void 0 ? void 0 : option.invalid) || 'Invalid Phone Number'; // option is the error message
};
validate_js_1.default.validators.phoneNumber = function (value, option) {
    if (PhoneUtil_1.PhoneUtil.isValid(value)) {
        return undefined;
    }
    return option; // option is the error message
};
validate_js_1.default.validators.phoneNumberOptional = function (value, option) {
    if (!value || value.length === 0 || PhoneUtil_1.PhoneUtil.isValid(value)) {
        return undefined;
    }
    return option; // option is the error message
};
validate_js_1.default.validators.phoneNumberCustomer = function (value, option) {
    var regex = RegExp('^(\\+?[0-9]+)((\\-[0-9]+)+)$');
    if (!value || value.length === 0 || regex.test(value)) {
        return undefined;
    }
    return option; // option is the error message
};
validate_js_1.default.validators.timeOptional = function (value, option) {
    var regex = RegExp('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$');
    if (!value || value.length === 0 || regex.test(value)) {
        return undefined;
    }
    return option; // option is the error message
};
validate_js_1.default.validators.color = function (value, option) {
    if (!value || value.length === 0 || ValidationColor_1.default(value)) {
        return undefined;
    }
    return option; // option is the error message
};
validate_js_1.default.validators.sesTemplateBraces = function (value, option) {
    var _a, _b;
    if (!value || value.length === 0) {
        return;
    }
    var startBraceMatchedArray = (_a = value.match(/{{/g)) !== null && _a !== void 0 ? _a : [];
    var endBraceMatchedArray = (_b = value.match(/}}/g)) !== null && _b !== void 0 ? _b : [];
    if (startBraceMatchedArray.length === endBraceMatchedArray.length) {
        return;
    }
    // eslint-disable-next-line consistent-return
    return option.message;
};
var variableFormat = /{{.+?}}/g;
var allowedSesTemplateVariable = [
    '{{last_name}}',
    '{{first_name}}',
    '{{company_name}}',
    '{{office_name}}',
    '{{department_name}}',
    '{{free_text1}}',
    '{{free_text2}}',
    '{{free_text3}}',
    '{{free_text4}}',
    '{{free_text5}}',
    '{{opt_out_url}}',
    '{{contentPrefix}}',
    '{{post_name}}',
    '{{phonetic_company_name}}',
    '{{phonetic_last_name}}',
    '{{phonetic_first_name}}',
    '{{tel1}}',
    '{{tel2}}',
    '{{fax}}',
    '{{mobile_phone}}',
    '{{country_name}}',
    '{{zipcode}}',
    '{{subdivision_name}}',
    '{{address}}',
    '{{building}}',
    '{{url}}',
];
validate_js_1.default.validators.sesTemplateVariables = function (value, option) {
    var matched = value.match(variableFormat);
    if (matched === null) {
        return;
    }
    var filtered = matched.filter(function (it) { return !allowedSesTemplateVariable.includes(it); });
    if (filtered.length > 0) {
        var variableNames = filtered.filter(function (it, i, array) { return array.indexOf(it) === i; }).join('、');
        return option.message.replace('%{variable_name}', variableNames);
    }
};
var ValidatorUtil = /** @class */ (function () {
    function ValidatorUtil() {
    }
    ValidatorUtil.validatePhoneNumber = function (value) {
        return ValidatorUtil.validateValue(value, Constraint_1.default.phoneNumber);
    };
    ValidatorUtil.validateValue = function (value, constraint) {
        var result = validate_js_1.default({ input: value }, { input: constraint });
        if (result) {
            return result.input[0];
        }
        return undefined;
    };
    ValidatorUtil.validateForm = function (fieldMap) {
        var keys = Object.keys(fieldMap);
        var response = {};
        keys.forEach(function (key) {
            response[key] = ValidatorUtil.validateField(fieldMap[key]);
        });
        return response;
    };
    ValidatorUtil.validateFormField = function (fieldMap, field) {
        var keys = Object.keys(fieldMap);
        var response = {};
        keys.forEach(function (key) {
            if (key === field) {
                response[key] = ValidatorUtil.validateField(fieldMap[key]);
            }
            else {
                response[key] = fieldMap[key];
            }
        });
        return response;
    };
    ValidatorUtil.validateField = function (field) {
        var _a;
        var clonedField = __assign({}, field);
        if (field.constraint) {
            var errorId = ValidatorUtil.validateValue(field.value, field.constraint);
            if (field.optional &&
                (!field.value ||
                    field.value.length === 0 ||
                    (field.value.length === 1 && !((_a = field.value) === null || _a === void 0 ? void 0 : _a[0])))) {
                errorId = undefined;
            }
            if (errorId) {
                clonedField.errorId = errorId;
                clonedField.invalid = true;
            }
            else {
                clonedField.errorId = '';
                clonedField.invalid = false;
            }
        }
        return clonedField;
    };
    ValidatorUtil.countError = function (fieldMap) {
        var errorCount = 0;
        var keys = Object.keys(fieldMap);
        keys.forEach(function (key) {
            if (fieldMap[key].invalid) {
                errorCount += 1;
            }
        });
        return errorCount;
    };
    ValidatorUtil.hasError = function (fieldMap) {
        var errorCount = ValidatorUtil.countError(fieldMap);
        return errorCount != 0;
    };
    return ValidatorUtil;
}());
exports.default = ValidatorUtil;
//# sourceMappingURL=ValidatorUtil.js.map